import getBuildConfigEasyRow from "../DataDisplayRow/BuildConfigEasyRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";

class BuildConfigEasyRowTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getBuildConfigEasyRow()
    }
}

let buildConfigEasyRowTable: BuildConfigEasyRowTable | null = null;

export default function getBuildConfigEasyTable(): BuildConfigEasyRowTable {
    if (buildConfigEasyRowTable === null)
      buildConfigEasyRowTable = new BuildConfigEasyRowTable()
    return buildConfigEasyRowTable
}